import {t} from "@lingui/macro";
import {Type} from "../helper";

export function getWebBaseUrl(transactionType, allowNotFound) {
    switch (transactionType) {
        case Type.opening_balance:
        case Type.opening:
        case Type.opening_stock_adjustment:
        case Type.asset_depreciation:
        case Type.asset_disposal:
        case Type.bank_adjustment:
            return false;
        case Type.sale_quote:
            return '/sales/quotes';
        case Type.sale_order:
            return '/sales/orders';
        case Type.sale_delivery_order:
            return '/sales/delivery-orders';
        case Type.sale_invoice:
        case Type.sale_invoice_cash:
            return '/sales/invoices';
        case Type.opening_invoice:
            return '/sales/opening-invoices';
        case Type.sale_credit_note:
            return '/sales/credit-notes';
        case Type.opening_sale_credit_note:
            return '/sales/opening-credit-notes';
        case Type.sale_payment:
            return '/sales/payments';
        case Type.sale_refund:
            return '/sales/refunds';
        case Type.purchase_order:
            return '/purchases/orders';
        case Type.purchase_goods_received_note:
            return '/purchases/goods-received-notes';
        case Type.purchase_bill:
        case Type.purchase_bill_cash:
        case Type.purchase_bill_claim:
            return '/purchases/bills';
        case Type.opening_bill:
            return '/purchases/opening-bills';
        case Type.purchase_credit_note:
            return '/purchases/credit-notes';
        case Type.opening_purchase_credit_note:
            return '/purchases/opening-credit-notes';
        case Type.purchase_payment:
            return '/purchases/payments';
        case Type.purchase_refund:
            return '/purchases/refunds';
        case Type.bank_income:
            return '/bank/incomes';
        case Type.bank_expense:
            return '/bank/expenses';
        case Type.bank_transfer:
            return '/bank/transfers';
        case Type.journal_entry:
            return '/accounting/journal-entries';
        case Type.contra:
            return '/accounting/contras';
        case Type.tax_deemed_payment:
            return '/accounting/deemed-payments';
        case Type.stock_adjustment:
            return '/stock/adjustments';
        case Type.stock_transfer:
            return '/stock/transfers';
        case Type.stock_value:
            return '/stock/values';

        case Type.minipos_order:
            return '/minipos/orders';
        default:
            if (allowNotFound)
                return false;
            throw new Error(t`No URL found for the transaction type: ${transactionType}`);
    }
}
